module.exports = __webpack_public_path__ + "static/media/italic.d5dc5f99.svg";